import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ShiftsBlock from './components/ShiftsBlock';
import HomePageBlock from './components/HomePageBlock';
import styles from './styles';
import EmailNotifications from './components/EmailNotifications';
import LateClockIn from './components/LateClockIn/index';
import GearIcon from 'assets/images/i-gear.svg';
import HomeIcon from 'assets/images/i2.svg';
import MailIcon from 'assets/images/i3.svg';
import ReportIcon from 'assets/images/i4.svg';
import LocationIcon from 'assets/images/location.svg';
import DwlPointOfContactIcon from 'assets/images/dwl-verification.svg';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TabPanel from './components/TabPanel/TabPanel';
import cl from 'classnames';
import Locations from './components/Locations/Locations';
import DwlPointOfContact from './components/DwlPointOfContact/DwlPointOfContact';
import FilingCabinetBlock from './components/FilingCabinetBlock';
import NavigationSystemBlock from './components/NavigationSystemBlock';

const SettingsForm = ({
  classes,
  pageType,
  errors,
  control,
  settings,
  tabValue,
  handleChange,
  getValues,
  watch,
  openSnackbar,
}) => {
  const { timeclock: timeclockValue } = ((getValues && getValues()) || {});
  const tabShift = Number(!!timeclockValue);

  function addProps(index) {
    return {
      id: `vertical-tab-${index}`,
      'aria-controls': `vertical-tabpanel-${index}`,
    };
  }

  return (
    <>
      <div className={classes.settingsWrapper}>
        <div className={classes.settingsTabs}>
          <Tabs
            orientation="vertical"
            value={tabValue}
            onChange={handleChange}
            aria-label="Vertical tabs"
            scrollButtons="off"
            className={classes.settingsTabsInner}
          >
            <Tab
              icon={
                <img
                  className={cl('superAdminTabIcon', classes.scaleUpI)}
                  src={GearIcon}
                  alt="shifts"
                />
              }
              label={<span>General</span>}
              {...addProps(0)}
            />
            <Tab
              icon={
                <img
                  className={cl('superAdminTabIcon', classes.scaleDownI)}
                  src={HomeIcon}
                  alt="home page"
                />
              }
              label={<span>Home Page</span>}
              {...addProps(1)}
            />
            <Tab
              icon={<BusinessCenterIcon className="filingCabinetIcon" />}
              label={<span>Filing Cabinet</span>}
              {...addProps(2)}
            />
            <Tab
              icon={<img className={'superAdminTabIcon'} src={MailIcon} alt="email" />}
              label={<span>Email Notification</span>}
              {...addProps(3)}
            />
            {timeclockValue && (
              <Tab
                icon={<img className={'superAdminTabIcon'} src={ReportIcon} alt="reports" />}
                label={<span>Reports</span>}
                {...addProps(4)}
              />
            )}
            <Tab
              icon={<img className={cl('superAdminTabIcon', classes.scaleDownII)} src={DwlPointOfContactIcon} alt="dwl point of contact" />}
              label={<span>DWL Point of Contact</span>}
              {...addProps(4 + tabShift)}
            />
            <Tab
              icon={<img className={cl('superAdminTabIcon', classes.scaleDownII)} src={LocationIcon} alt="locations" />}
              label={<span>Locations</span>}
              {...addProps(5 + tabShift)}
            />
          </Tabs>
        </div>

        <TabPanel classes={classes} value={tabValue} index={0}>
          <ShiftsBlock
            pageType={pageType}
            errors={errors}
            control={control}
            settings={settings}
            getValues={getValues}
            watch={watch}
          />
          <NavigationSystemBlock control={control} watch={watch} />
        </TabPanel>
        <TabPanel classes={classes} value={tabValue} index={1}>
          <HomePageBlock pageType={pageType} errors={errors} control={control} />
        </TabPanel>
        <TabPanel classes={classes} value={tabValue} index={2}>
          <FilingCabinetBlock control={control} />
        </TabPanel>
        <TabPanel classes={classes} value={tabValue} index={3}>
          <EmailNotifications pageType={pageType} errors={errors} control={control} getValues={getValues} />
        </TabPanel>
        {timeclockValue && (
          <TabPanel classes={classes} value={tabValue} index={4}>
            <LateClockIn pageType={pageType} errors={errors} control={control} />
          </TabPanel>
        )}
        <TabPanel classes={classes} value={tabValue} index={4 + tabShift}>
          <DwlPointOfContact pageType={pageType} errors={errors} control={control} openSnackbar={openSnackbar} />
        </TabPanel>
        <TabPanel classes={classes} value={tabValue} index={5 + tabShift}>
          <Locations pageType={pageType} errors={errors} control={control} openSnackbar={openSnackbar} />
        </TabPanel>
      </div>
    </>
  );
};

SettingsForm.propTypes = {
  classes: propTypes.object.isRequired,
  pageType: propTypes.string.isRequired,
  control: propTypes.object.isRequired,
  errors: propTypes.object.isRequired,
};

export default withStyles(styles)(SettingsForm);
